import httpService from '../../../../services/httpService';
import { PromptRequest, PromptResponse } from '../interfaces/chatbot.types';

const CHATBOT_BASE = '/chatbot';

export const ChatClient = {
  sendPrompt: (data: PromptRequest): Promise<{ data: PromptResponse }> => {
    return httpService.post<PromptResponse>(`${CHATBOT_BASE}/prompt`, data);
  },

  // Direct API calls for quick action chips (bypasses Gemini)
  directApiCall: async (endpoint: string, params?: Record<string, string>): Promise<{ data: any }> => {
    try {
      const response = await httpService.get(endpoint, { params });
      return response;
    } catch (error: any) {
      console.error(`Direct API call failed for ${endpoint}:`, error);
      // Return empty data structure on error
      return { data: { records: [], total_no_of_records: 0, no_of_records: 0 } };
    }
  },
};
